import { Service } from '@tino-frontend/adapters'
import { AskCreditAnalysisPayload, CreditLimitRaisePayload } from '@types'

export class CreditLimitService {
  constructor(
    private readonly merchantBff: Service,
    private readonly supplierBff: Service
  ) {}

  requestRaise(
    companyId: string,
    payload: CreditLimitRaisePayload
  ): Promise<void> {
    return this.merchantBff.post(
      `/v1/company/${companyId}/request-raise-limit`,
      payload
    )
  }

  askCreditAnalysis(payload: AskCreditAnalysisPayload): Promise<void> {
    return this.supplierBff.post(`/v1/merchants`, payload)
  }
}
